// extracted by mini-css-extract-plugin
export default {"theme-container":"ButtonLinkComponent_theme-container__BkVFG","button":"ButtonLinkComponent_button__ESyLE"};